/**
 *
 * @/services/endpoints/groups.js
 *
 */

//
// IMPORTS
//

import { httpGet, httpPost, httpDelete } from "@/services/api/http"
import { buildGroupRequestPayload } from "@/services/helpers/groups"
import { getUserID, getUserUID } from "@/services/endpoints/session"
import { version, PARTNER } from "@/constants"

//
//
//

// --- GESTÃO DO GRUPO

// Criar grupo
export const apiCreateGroup = obj => httpPost({ route: "api/v1/groups", fields: buildGroupRequestPayload(obj), headers: { "Client": "WEB", "Partner": PARTNER, "X-App-Version": version, "User-ID": getUserID() }, onUploadProgress: obj.onUploadProgress })

// --- AÇÕES EM TERCEIROS NO GRUPO

// Define o nível do usuário
export const apiSetGroupUserLevel = (groupID, userID, level) => httpPost({ route: `api/v1/groups/${groupID}/users/${userID}/level`, fields: { level }, headers: { "Client": "WEB", "Partner": PARTNER, "X-App-Version": version, "User-ID": getUserID() } })
// Retirar usuário
export const apiRemoveUserFromGroup = (groupID, userID) => httpDelete({ route: `api/v1/groups/${groupID}/users/${userID}`, headers: { "Client": "WEB", "Partner": PARTNER, "X-App-Version": version, "User-ID": getUserID() } })
/*
// [staging-portaltelemedicina / master-portaltelemedicina]
// Define o usuário como município ou não
export const apiUpdateGroupUserMunicipalityRole = (groupID, userID, isMunicipality) => httpPost({ route: `api/v1/groups/${groupID}/users/${userID}/municipality-role`, fields: { isMunicipality }, headers: { "X-Client-Type": "WEB", "X-Partner": PARTNER, "X-App-Version": version, "X-User-ID": getUserUID() } })
// Define os municípios do usuário
// export const apiUpdateGroupUserMunicipalities = (groupID, userID, municipalities) => httpPost({ route: `api/v1/groups/${groupID}/users/${userID}/municipalities`, fields: { municipalities }, headers: { "X-Client-Type": "WEB", "X-Partner": PARTNER, "X-App-Version": version, "X-User-ID": getUserUID() } })
// Atribui município ao usuário
export const apiAttachMunicipalityToGroupUser = (groupID, userID, municipalityID) => httpPost({ route: `api/v1/groups/${groupID}/users/${userID}/municipalities/${municipalityID}`, headers: { "X-Client-Type": "WEB", "X-Partner": PARTNER, "X-App-Version": version, "X-User-ID": getUserUID() } })
// Desvincular município ao usuário
export const apiDettachMunicipalityFromGroupUser = (groupID, userID, municipalityID) => httpDelete({ route: `api/v1/groups/${groupID}/users/${userID}/municipalities/${municipalityID}`, headers: { "X-Client-Type": "WEB", "X-Partner": PARTNER, "X-App-Version": version, "X-User-ID": getUserUID() } })
// [staging-portaltelemedicina / master-portaltelemedicina]
*/

// --- VINCULAR ESCALA AO USUÁRIO

// Endpoint para vincular uma escala a um usuário do grupo
export const apiAttachScaleToGroupUser = (groupID, userID, scaleID) => httpPost({
  route: `api/v1/groups/${groupID}/users/${userID}/attach-scale/${scaleID}`,
  headers: {
    "X-Client-Type": "WEB",
    "X-Partner": PARTNER,
    "X-App-Version": version,
    "X-User-ID": getUserUID()
  }
})

// Endpoint para desvincular uma escala de um usuário do grupo
export const apiDetachScaleFromGroupUser = (groupID, userID, scaleID) => httpDelete({
  route: `api/v1/groups/${groupID}/users/${userID}/detach-scale/${scaleID}`,
  headers: {
    "X-Client-Type": "WEB",
    "X-Partner": PARTNER,
    "X-App-Version": version,
    "X-User-ID": getUserUID()
  }
})

// --- GERENCIAR LOCAIS DO GRUPO

// Adicionar
export const apiAddGroupPlace = (groupID, name) => httpPost({ route: `api/v1/groups/${groupID}/places`, fields: { name }, headers: { "Client": "WEB", "Partner": PARTNER, "X-App-Version": version, "User-ID": getUserID() } })
// Excluir
export const apiDeleteGroupPlace = (groupID, placeID) => httpDelete({ route: `api/v1/groups/${groupID}/places/${placeID}`, headers: { "Client": "WEB", "Partner": PARTNER, "X-App-Version": version, "User-ID": getUserID() } })

// --- TRANSFERIR MASTER DO GRUPO

// Endpoint para transferir a função de Master para outro usuário do grupo
// curl -X POST "http://localhost:8000/api/v1/groups/{groupID}/transfer-master" \
//   -H "X-Client-Type: WEB" \
//   -H "X-Partner: DEFAULT" \
//   -H "X-App-Version: 1.0.0" \
//   -H "X-User-ID: akoBvcjO4MhIzRan19eIV7dOJXQ2" \
//   -H "Content-Type: application/x-www-form-urlencoded" \
//   -d "newMasterID=jm1epaODyJNZmc1mpCeOq8EeQQl1"
export const apiTransferGroupMaster = ({ groupID, newMasterUserID }) => httpPost({
  route: `api/v1/groups/${groupID}/transfer-master`,
  fields: { newMasterID: newMasterUserID },
  headers: {
    "X-Client-Type": "WEB",
    "X-Partner": PARTNER,
    "X-App-Version": version,
    "X-User-ID": getUserUID()
  }
})

// --- VERIFICAR SE USUÁRIO ESTÁ NO GRUPO

// Endpoint para verificar se um usuário está no grupo pelo e-mail
// curl "http://localhost:8000/api/v1/groups/{groupID}/check-user-in-group?userEmail=hallan@agencianeoplan.com.br" \
//   -H "X-Client-Type: WEB" \
//   -H "X-Partner: DEFAULT" \
//   -H "X-App-Version: 1.0.0" \
//   -H "X-User-ID: akoBvcjO4MhIzRan19eIV7dOJXQ2"
export const apiCheckUserInGroup = ({ groupID, userEmail }) => httpGet({
  method: 'GET',
  route: `api/v1/groups/${groupID}/check-user-in-group?userEmail=${userEmail}`,
  headers: {
    "X-Client-Type": "WEB",
    "X-Partner": PARTNER,
    "X-App-Version": version,
    "X-User-ID": getUserUID()
  }
})

// --- BUSCAR MASTER DO GRUPO

// Endpoint para obter o usuário master de um grupo
// curl -X GET "http://localhost:8000/api/v1/groups/{groupID}/master" \
//   -H "X-Client-Type: WEB" \
//   -H "X-Partner: DEFAULT" \
//   -H "X-App-Version: 1.0.0" \
//   -H "X-User-ID: jm1epaODyJNZmc1mpCeOq8EeQQl1"
export const apiGetGroupMaster = ({ groupID }) => httpGet({
  method: 'GET',
  route: `api/v1/groups/${groupID}/master`,
  headers: {
    "X-Client-Type": "WEB",
    "X-Partner": PARTNER,
    "X-App-Version": version,
    "X-User-ID": getUserUID()
  }
})

// --- OUTRO

// Lista de usuários do grupo
export const apiGetGroupUsers = ({ groupID, itemsPerPage, page, search }) => httpPost({ route: `api/v1/groups/${groupID}/users`, fields: { itemsPerPage, page, search }, headers: { "Client": "WEB", "Partner": PARTNER, "X-App-Version": version, "User-ID": getUserUID()/* , "If-Modified-Since": ifModifiedSince */ } })
